var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig},on:{"blur":_vm.onBlur,"input":_vm.onInput},model:{value:(_vm.vmodel),callback:function ($$v) {_vm.vmodel=$$v},expression:"vmodel"}})}
var staticRenderFns = []

export { render, staticRenderFns }